import { Alert, Link } from '@mm/components';
import React from 'react';
import { FacebookPageIcon } from '../FacebookPageIcon/FacebookPageIcon';
import arrayIcon from './arrow-gray.png';
import './SmsWarningAlert.pcss';

type Props = {
  isVisible: boolean;
  setIsVisibleSmsWarningAlert: (isVisible: boolean) => void;
};

export const SmsWarningAlert = (props: Props) => {
  const { isVisible, setIsVisibleSmsWarningAlert } = props;

  const onCloseAlert = () => {
    setIsVisibleSmsWarningAlert(false);
  };

  return isVisible ? (
    <div className="sms-warning">
      <FacebookPageIcon />
      <img src={arrayIcon} className="sms-warning__arrow-icon" />
      <div>
        <Alert
          className="sms-warning__alert"
          type="warning"
          closeIconProps={{ onClick: onCloseAlert }}
        >
          Messages over 160 characters will be sent as MMS, with an image
          attached. More info
          <Link
            className="sms-warning__link"
            href="https://mobilemonkey.com/help/article/4ofkhxvfdx-what-happens-when-my-text-exceeds-160-characters-on-sms"
            isBlank
          >
            {' '}
            here
          </Link>
        </Alert>
      </div>
    </div>
  ) : null;
};
